import React from 'react';
import LegalPage from './LegalPage';
import { Building2 } from 'lucide-react';

const ImprintPage = () => {
  return (
    <LegalPage 
      title="Impressum" 
      contentKey="legal_imprint"
      icon={Building2}
    />
  );
};

export default ImprintPage;
